import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, finalize, map } from 'rxjs/operators';
import { LocalStorageKeyEnum } from './localStorage.key.enum';
import { Error } from './models/error';
import { ModalErrorService } from './services/shared/modal-error.service';
import { LoadingService } from './services/shared/loading.service';
import { AuthService } from './services/auth/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { showLoadingHelper } from './utils/showLoadingHelper';
import { Router } from '@angular/router';

@Injectable()
export class HTTPListener implements HttpInterceptor {
  constructor(
    private modalService: ModalErrorService,
    private loadingService: LoadingService,
    private jwtHelper: JwtHelperService,
    public authService: AuthService,
    private router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ignoring loading state if loading dropdowns on sections
    if (showLoadingHelper(req)) {
      this.loadingService.pushLoadingRequests(req);
    }
    return next.handle(this.addAuthenticationToken(req)).pipe(
      map((event) => {
        return event;
      }),
      catchError((error) => {
        if (showLoadingHelper(req)) {
          this.loadingService.popLoadingRequests();
        }
        let errorTraceId = null;
        if (error && error.headers) {
          errorTraceId = error.headers.get('x-cloud-trace-context');
        }
        if (error instanceof HttpErrorResponse) {
          var refreshToken = false;
          if (error.status === 500 || error.status === 503) {
            if (error.error && error.message) {
              error.error.errorTraceId = errorTraceId;
              this.modalService.emitModalOpen(error.error as Error);
            } else {
              this.modalService.emitModalOpen({
                details: null,
                message: '500 - Internal Server Error',
                timestamp: error.error.timestamp,
                validationErrors: null,
                errorTraceId,
              });
            }
          }
          else if (error.status === 401) {
            refreshToken = true;
            if (document.querySelector<HTMLElement>("#blanket")) {
              document.querySelector<HTMLElement>("#blanket").classList.add('d-none');
            }
            this.router.navigate(["/login"]);
            return throwError(error.error);
          }
          else if (error.status !== 401) {
            if(error.url.includes('graph.microsoft.com/v1.0/me/photo/$value') && error.status === 404){
              console.log("errore nessuna foto su microsoft");
            }
            else
            if (!error.url.includes('jira_user/activate/?uid=') || error.status !== 502) {
              if (!(error.url.includes('api/v1/order/budget/') && error.url.includes('/bulk'))) {
                // if error is validation error
                if (error.error.validationErrors && error.error.validationErrors.length > 0) {
                  // if any validation field is null, we need to open up modal isntead of just highlighting the field
                  for (let i = 0; i < error.error.validationErrors.length; i++) {
                    let er = error.error.validationErrors[i];
                    if (!er.fieldName) {
                      error.error.errorTraceId = errorTraceId;
                      this.modalService.emitModalOpen(error.error as Error);
                      break;
                    }
                  }
                } else if (error.error && error.message) {
                  // if not validation error, show the modal
                  error.error.errorTraceId = errorTraceId;
                  if (!(error.url.includes('user/jira/activate'))) {
                    this.modalService.emitModalOpen(error.error as Error);
                  }
                }
                return throwError(error.error);
              }
            }
          }
          else {
            refreshToken = true;
          }
        }
        else {
          // Token is Expired! Why not try to refresh...
          // this.authService.refreshToken().then((result) => {
          //   return next.handle(this.addAuthenticationToken(req));
          // });
          if (!refreshToken) {
            return next.handle(error)
          }
        }
        if (error.status === 502 && error.url.includes('jira_user/activate/?uid=')) {
          return throwError(error.error);
        }
        if (error.status === 400 && error.url.includes('api/v1/order/budget/') && error.url.includes('/bulk')) {
          return throwError(error.error);
        }
        return next.handle(error);
      }),
      finalize(() => {
        if (showLoadingHelper(req)) {
          this.loadingService.popLoadingRequests();
        }
      })
    );
  }

  addAuthenticationToken(request) {
    let accessToken = null;
    const user = localStorage.getItem(LocalStorageKeyEnum.USER);

    if (user) {
      const userObj = JSON.parse(user);
      const isExpiredToken = this.jwtHelper.isTokenExpired(userObj.idToken);
      if (!isExpiredToken) {
        accessToken = `Bearer ` + userObj.idToken;
      }
    }

    // If access token is null this means that user is not logged in
    // And we return the original request
    if (!accessToken) {
      return request;
    }

    // We clone the request, because the original request is immutable
    return request.clone({
      setHeaders: {
        Authorization: accessToken,
      },
    });
  }
}
